export default __webpack_public_path__ + "static/media/investment-financing-monitor.c1d4ae4d.png";